import React from 'react';
import c from 'classnames';
import { PapiEditorText, PapiUser } from '@wix/da-papi-types';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import TextRenderer from '../../../TextRenderer/TextRenderer';
import DescTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/DeviationDescription';

import s from './DetailsDumb.scss';

interface Props {
  className?: string;
  title?: string;
  withAuthorDetails?: boolean;
  withOwnerDetails?: boolean;
  owner?: PapiUser;
  author?: PapiUser;
  rightSlot?: React.ReactNode;
  withDescriptionBlock?: boolean;
  description?: PapiEditorText | string | null;
}

const USER_AVATAR_SIZE = 28;

const DetailsDumb: React.FC<Props> = ({
  className,
  title,
  withAuthorDetails = true,
  withOwnerDetails = false,
  author,
  owner,
  rightSlot,
  withDescriptionBlock,
  description,
}) => {
  return (
    <Flex direction="column" className={c(s['root'], className)}>
      <Flex direction="row" alignItems="stretch">
        <div className={s['left-cell']}>
          {withAuthorDetails && (
            <div className={s['avatar']}>
              <UserAvatar user={author} size={USER_AVATAR_SIZE} />
            </div>
          )}
        </div>
        <div className={c(s['two-center-cells'])}>
          <div className={s['title']}>{title}</div>
          {author && (
            <div className={s['username']}>
              {withAuthorDetails && <UserLink user={author} />}
            </div>
          )}
        </div>
        <div className={s['right-cell']}>{rightSlot}</div>
      </Flex>
      {withDescriptionBlock && (
        <div className={s['description']}>
          {description &&
            (typeof description === 'string' ? (
              description
            ) : (
              <TextRenderer
                className={s['description-text']}
                textContent={description}
                tipTapViewer={DescTiptapViewer}
              />
            ))}
        </div>
      )}
    </Flex>
  );
};
DetailsDumb.displayName = 'DetailsDumb';

export default DetailsDumb;
